module.exports = __webpack_public_path__ + "static/media/ana-lucena-AL.b3ee0cf1.png";